<template>
  <section class="content">
    <div class="column center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="warning-block">
        自備飲料杯模組為新功能，已規劃至「
        <a @click="goto" class="cursor-pointer"> 新後台管理系統 > 商品管理 > 一般商品 > 自備飲料杯管理</a>
      」，請至新後台管理系統操作相關內容。
      </div>
    </div>
  </section>
</template>

<script>
import { setSharedToken } from '../../../assets/js/shared-token.js'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CupDiscountTable',
  extends: NdExtendHandleMenu,

  data () {
    return {
      isLoading: true
    }
  },

  mounted () {
    this.getExtendHandleMenuInfo()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  },
  methods: {
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = `${this.$config.bdms}product-center/products/cup-discount`
    }
  }
}
</script>
<style scpoed>
.column {
  display: flex;
  flex-direction: column;
}
.warning-block {
  padding: 10px;
  border: 1px solid #F39C12;
  background-color: #FFF4E3;
  margin-top: 4px;
  margin-bottom: 12px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// CupDiscountTable.vue?f7f3b50c